var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOccurrenceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.584,
    height: 43.097,
    viewBox: "0 0 44.584 43.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-megaphone-5279252",
    d: "M124.819,78.879l-.424.234h-9.483a10.8,10.8,0,0,0-1.651,21.266v7.741a4.954,4.954,0,1,0,9.908,0v-7.459h1.227l.424.234Zm18.164,19.13a8.3,8.3,0,0,0,0-16.244V71.653a1.659,1.659,0,0,0-.811-1.427,1.642,1.642,0,0,0-1.636-.025l-12.457,6.877a1.67,1.67,0,0,1,.043.376v24.864a1.67,1.67,0,0,1-.043.376l12.457,6.877a1.642,1.642,0,0,0,1.636-.025,1.659,1.659,0,0,0,.811-1.427Z",
    transform: "translate(-105.004 -69.995)",
    fill: "#ddd",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurrenceIcon);
export default __webpack_public_path__ + "static/media/occurrence_icon.992f5b1f992010054000605b8474484b.svg";
export { ForwardRef as ReactComponent };